module.exports={
  "%s days": "%s dage",
  "Taking place at %s.": "Finder sted den %s.",
  "This event is being organized by %s.": "Denne event arrangeres af %s.",
  "Organized by %s.": "Arrangeres af %s.",
  "Taking place at %s and being organized by %s.": "Finder sted den %s og arrangeres af %s.",
  "Read more": "LÃ¦s mere"
}
